import React from 'react';

import { LegacyText, LegacyBox } from '@gogame/components';
import { withForm, FormField, DialogV2 } from '@gogame/form';

import {
  AmountField,
  BidingStrategyField,
  AffectedDimensions,
  getNewAmount,
  Note,
} from './components';
import {
  LOWEST_COST_WITH_MIN_ROAS,
  LOWEST_COST_WITH_BID_CAP,
  TARGET_COST,
  BIDING_STRATEGY,
  BID_AMOUNT,
  MIN_ROAS_BID,
} from './constants';

const BidAmountForm = withForm({
  enableReinitialize: true,
  mapPropsToValues: ({ mapEntityToValues, entities }) => {
    if (entities.length === 1) {
      return mapEntityToValues(entities[0]);
    }
    return {};
  },
  handleSubmit: (
    {
      amountAction,
      [BIDING_STRATEGY]: bindingStrategy,
      [MIN_ROAS_BID]: minRoasBid,
    },
    { props }
  ) => {
    props.onSubmit(
      props.entities.map((entity) => {
        const { [BID_AMOUNT]: initialBidAmount, ...other } =
          props.mapEntityToValues(entity);
        const newAmount = amountAction
          ? getNewAmount(initialBidAmount, amountAction)
          : null;
        return {
          ...other,
          [BIDING_STRATEGY]: bindingStrategy,
          [MIN_ROAS_BID]: minRoasBid,
          [BID_AMOUNT]:
            newAmount !== null ? +(newAmount * 100).toFixed(2) : newAmount,
        };
      })
    );
  },
})(
  ({
    loading,
    values,
    initialValues,
    dimensionName,
    entities,
    withBidingStrategy,
    updateWarning,
    onClose,
    onExited,
    open,
  }) => {
    const strategy = values[BIDING_STRATEGY];
    const initialMinRoasBid = initialValues[MIN_ROAS_BID];
    const initialBidAmount = initialValues[BID_AMOUNT];

    let amountVisible;
    let minRoasVisible;
    if (withBidingStrategy && strategy) {
      amountVisible = [LOWEST_COST_WITH_BID_CAP, TARGET_COST].includes(
        strategy
      );
      minRoasVisible = LOWEST_COST_WITH_MIN_ROAS === strategy;
    } else {
      amountVisible = !!initialBidAmount || !initialMinRoasBid;
      minRoasVisible = !!initialMinRoasBid;
    }

    return (
      <DialogV2
        onClose={onClose}
        open={open}
        onExited={onExited}
        fullWidth={true}
        size={'md'}
        loading={loading}
      >
        <DialogV2.Title title={`Edit ${dimensionName} Bid Amount`} />
        <DialogV2.Content>
          <LegacyBox vertical={true}>
            <AffectedDimensions
              dimensionName={dimensionName}
              entities={entities}
            />
            {withBidingStrategy ? ( //TODO: remove <LegacyBox style={{ padding: '0 8px' }}> after migration html to Material
              <LegacyBox style={{ padding: '0 8px' }}>
                <BidingStrategyField name={BIDING_STRATEGY} />
              </LegacyBox>
            ) : null}
            {amountVisible ? (
              <AmountField
                name={'amountAction'}
                initial={values[BID_AMOUNT]}
                withPreview={entities.length <= 1}
                updateWarning={updateWarning}
              />
            ) : null}
            {minRoasVisible ? (
              <LegacyBox style={{ padding: '0 8px 16px' }} vertical={true}>
                <FormField.TextField
                  type={'percent'}
                  name={MIN_ROAS_BID}
                  width={'200px'}
                  label={'Min ROAS amount'}
                />
                <LegacyText style={{ padding: '0 8px' }}>
                  Check Min ROAS value in <strong>Min ROAS Bid column</strong>
                </LegacyText>
              </LegacyBox>
            ) : null}
            <Note
              dimensionName={dimensionName}
              unit={'bid'}
              bulk={entities.length > 1}
            />
          </LegacyBox>
        </DialogV2.Content>
        <DialogV2.Actions>
          <DialogV2.CloseButton />
          <DialogV2.SubmitButton />
        </DialogV2.Actions>
      </DialogV2>
    );
  }
);

export default BidAmountForm;
